module.exports = __webpack_public_path__ + "static/media/akshay.362284ac.jpg";